<template>
  <router-view></router-view>
</template>

<script>
  export default {}
</script>



// WEBPACK FOOTER //
// src/pages/Group.vue